export default "__VITE_ASSET__c924a046__"